import React, { useState, useEffect } from 'react';
import '../styles/CookieConsent.css';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    // Проверяем, было ли уже дано согласие
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'true') {
      setAccepted(true);
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'true');
    setAccepted(true);
    setVisible(false);
    // Здесь можно активировать скрипты аналитики, если они есть
    // Например: if (window.gtag) window.gtag('consent', 'update', { ... });
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'false');
    setAccepted(false);
    setVisible(false);
    // Если требуется отключить аналитику – можно выполнить действия
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <p>
            Мы используем файлы cookie, чтобы улучшить работу сайта и проанализировать трафик.
            Продолжая использовать наш сайт, вы соглашаетесь с нашей{' '}
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
             Политикой Конфиденциальности
            </a>.
          </p>
        </div>
        <div className="cookie-buttons">
          <button className="cookie-btn cookie-accept" onClick={acceptCookies}>
            Принять
          </button>
          <button className="cookie-btn cookie-decline" onClick={declineCookies}>
            Отклонить
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;